import _ from 'lodash';
import { BookingStatus, TravelTypes } from '../constants';

/**
 * Check if at least one seat has been selected for any passenger and seatSelectionWarning exists.
 * If exists then retrieves the seat selection warning message from the travel agency settings.
 * In case of trip confirmation page, check if isFlightTicketedOrCancelled.
 * @returns {Object} - An object containing showSeatSelectionWarning and seatSelectionWarning
 * and isFlightTicketedOrCancelled (used on confirmation page).
 */
const evaluateSeatSelectionWarning = (
  passengers,
  travelAgency,
  trip,
  tripConfirmation,
  isCheckoutPage,
) => {
  try {
    const seatSelectionWarning =
      travelAgency &&
      travelAgency.settings &&
      travelAgency.settings.terms &&
      travelAgency.settings.terms.seatSelectionWarning;

    if (!seatSelectionWarning) {
      return {
        doShowSeatSelectionWarning: null,
        seatSelectionWarning: null,
      };
    }

    const flightBookingRes =
      tripConfirmation &&
      tripConfirmation.bookingResponses &&
      (_.find(tripConfirmation.bookingResponses, (b) => b.mode === TravelTypes.flight) || {});

    const isFlightTicketedOrCancelled =
      (flightBookingRes && flightBookingRes.isTicketed) ||
      (flightBookingRes && flightBookingRes.bookingStatus === BookingStatus.cancelled);

    const isFlightBookingFailed = flightBookingRes && _.isEmpty(flightBookingRes.bookingStatus);

    const hasSeatSelected =
      passengers &&
      typeof passengers === 'object' &&
      Object.keys(passengers).length > 0 &&
      Object.values(passengers).some(
        (passenger) =>
          passenger &&
          passenger.travelerPreferences &&
          passenger.travelerPreferences.flightSeatNumbers &&
          typeof passenger.travelerPreferences.flightSeatNumbers === 'object' &&
          Object.keys(passenger.travelerPreferences.flightSeatNumbers).length > 0 &&
          !!Object.values(passenger.travelerPreferences.flightSeatNumbers).find(
            (flightSeat) => flightSeat && flightSeat.seatNumber,
          ),
      );

    const doShowSeatSelectionWarning = !!(
      trip &&
      trip.flightItinerary &&
      hasSeatSelected &&
      seatSelectionWarning &&
      (isCheckoutPage || !isFlightTicketedOrCancelled) &&
      !isFlightBookingFailed
    );

    return { doShowSeatSelectionWarning, seatSelectionWarning };
  } catch (error) {
    // Although errors are unlikely, added try-catch for robustness
    console.log('ERROR occured in getShowSeatSelectionWarning: ', error);
    return {
      doShowSeatSelectionWarning: null,
      seatSelectionWarning: null,
    };
  }
};

export default evaluateSeatSelectionWarning;
